// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1jtVv","head":"Table_head__38xhq","col":"Table_col__2JA8G"};